import { useQuery } from "@tanstack/react-query";
import { boronClient } from "../../api";
import { createError, HTTPErrors } from "../../errors";
import { StudentFilterParams } from "../../helpers/FiltersHelper";
import type { StudentsWithAnswersResponse } from "./types";

const path =
  "/api/v1/sections/{section_id}/drill_learning_materials/{steak_material_code}/students_with_answers" as const;

type Props = {
  sectionId: string;
  materialCode?: string;
  drillContentPublicId: string | undefined;
  studentFilterParams: StudentFilterParams;
};

export const useFetchStudentsWithAnswers = ({
  sectionId,
  materialCode,
  drillContentPublicId,
  studentFilterParams,
}: Props) => {
  return useQuery<StudentsWithAnswersResponse, HTTPErrors>({
    queryKey: [
      "studentsWithAnswers",
      sectionId,
      materialCode,
      drillContentPublicId,
      studentFilterParams,
    ],
    queryFn: async () => {
      const { response } = await boronClient.GET(path, {
        params: {
          path: {
            section_id: sectionId,
            steak_material_code: materialCode!,
          },
          query: {
            drill_content_public_id: drillContentPublicId!,
            ...studentFilterParams,
          },
        },
      });

      if (response.ok) {
        return response.json() as Promise<StudentsWithAnswersResponse>;
      }

      throw await createError(response);
    },
    retry: 0,
    enabled: materialCode !== undefined && drillContentPublicId !== undefined,
  });
};
